// frontend/src/features/account/components/settings/shared/SettingsInput.tsx

import * as React from 'react';
import { cn } from '@/utils/cn';

interface SettingsInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

export const SettingsInput: React.FC<SettingsInputProps> = ({ label, className, ...props }) => (
  <div className='flex w-full flex-col gap-2'>
    <label className='font-sans text-14 font-medium leading-21 text-settings-text'>{label}</label>
    <input
      className={cn(
        'h-[47px] w-full rounded-10 px-4',
        'border border-gray-200 bg-white',
        // Input Value Styles: Keep existing or default
        'font-sans text-16 text-brand-800',
        // Placeholder Styles (Specified in task)
        'placeholder:font-jakarta placeholder:text-14 placeholder:font-normal',
        'placeholder:leading-160 placeholder:tracking-neg-2 placeholder:text-brand-800',
        // Focus & Disabled States
        'focus:border-brand-300 focus:outline-none focus:ring-1 focus:ring-brand-300',
        'disabled:bg-gray-50 disabled:text-gray-500',
        className
      )}
      {...props}
    />
  </div>
);
